export const defaultFontSizePx = 16
export const narrowContainerWidthRem = 48
export const narrowContainerWidthPx = narrowContainerWidthRem * defaultFontSizePx
export const normalContainerWidthRem = 75
export const cardMaxWidth = 33
export const textSelectionTooltipTestId = "text-selection-tooltip"
// Used to style the opens in new tab icon in links
export const linkWithExtraIconClass = "link-with-extra-icon"
